var render, staticRenderFns
import script from "./environment.vue?vue&type=script&lang=js&"
export * from "./environment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681d3120",
  null
  
)

export default component.exports